export function accountLibraryCacheKey(userId: string) {
  return `dahlini.account-library.v1.${userId}`;
}

export function clearAccountLibraryCache(userId: string) {
  try {
    window.localStorage.removeItem(accountLibraryCacheKey(userId));
  } catch {
    // Account sign-out must still succeed when browser storage is unavailable.
  }
}
